import React, { useEffect, useState } from 'react';
import { Container, Typography, Card, CardContent, Button, Switch, Box, Grid, createTheme } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../../utils/authService';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#7e3e1b',
    '&:hover': {
      backgroundColor: alpha('#7e3e1b', theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#7e3e1b',
  },
}));

const Pricing = (props) => {
  const navigate = useNavigate();
  const [subscribed, setSubscribed] = useState(false);

  const handleToggle = () => {
    props.setIsYearly(!props.isYearly);
  };

  useEffect(() => {
    const checkAccess = async () => {
      fetch(
        `https://server.nepeto.com/aniseller_sub_check/${getUser()}/`, // https://server.nepeto.com
        {
          mode: "cors",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setSubscribed(data);
        })
        .catch(() => {
        });
    };
    checkAccess();
  }, []);

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4, }}>
        <Typography variant="h2" component="h1" gutterBottom align="center" style={{ fontFamily: 'RobotoSlab', color: '#7e3e1b', }}>
          Pricing
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom align="center" style={{ fontFamily: 'RobotoSlab', color: '#7e3e1b', }}>
          Affordable monthly price for unlimited usage
        </Typography>
      </Box>

      <Grid container justifyContent="center">
        <Grid item style={{ display: "flex", flexDirection: "row" }}>
          <Card style={{ maxWidth: 350, backgroundColor: '#FCF8F3', margin: 'auto', textAlign: 'center', borderRadius: '15px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', }}>
            <CardContent>
              <Typography variant="h5" component="div" gutterBottom style={{ fontFamily: 'RobotoSlab', }}>
                Aniseller Monthly
              </Typography>
              {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
                <Typography style={{ fontFamily: 'RobotoSlab', }}>Monthly</Typography>
                <CustomSwitch checked={props.isYearly} onChange={handleToggle} style={{ color: '#7e3e1b', }} />
                <Typography style={{ fontFamily: 'RobotoSlab', }}>Yearly</Typography>
              </Box> */}

              {props.isYearly && <Typography style={{ fontFamily: 'RobotoSlab', fontSize: 14, }}>* billed yearly</Typography>}
              <Typography style={{ color: '#7e3e1b', fontFamily: 'RobotoSlab', fontSize: '2.5rem', fontWeight: 'bold', marginBottom: 5, }}>
                <span style={{ color: "red", textDecoration: "line-through", fontSize: "55%" }}>$49</span>${props.isYearly ? 24 : 29}<Typography component="span" variant="h6">/month</Typography>
              </Typography>
              <Typography style={{ fontFamily: 'RobotoSlab', display: 'flex', alignItems: 'center', margin: '10px 10px 10px 20px', }}>
                <CheckCircleIcon style={{ color: '#7e3e1b', }} sx={{ mr: 1 }} /> Amazon & Walmart Scanners
              </Typography>
              <Typography style={{ fontFamily: 'RobotoSlab', display: 'flex', alignItems: 'center', margin: '10px 10px 10px 20px', }}>
                <CheckCircleIcon style={{ color: '#7e3e1b', }} sx={{ mr: 1 }} /> Unlimited Scans
              </Typography>
              <Typography style={{ fontFamily: 'RobotoSlab', display: 'flex', alignItems: 'center', margin: '10px 10px 10px 20px', }}>
                <CheckCircleIcon style={{ color: '#7e3e1b', }} sx={{ mr: 1 }} /> Priority support
              </Typography>
              <Typography style={{ fontFamily: 'RobotoSlab', display: 'flex', alignItems: 'center', margin: '10px 10px 10px 20px', }}>
                <CheckCircleIcon style={{ color: '#7e3e1b', }} sx={{ mr: 1 }} /> 3 Days Free Trial
              </Typography>
              <Button
                variant="contained"
                disabled={subscribed}
                onClick={() => {
                  props.setIsFlipped(true);
                  if (!props.isAuth) {
                    navigate('/login');
                  } else {
                    window.location.href = `https://store.payproglobal.com/checkout?products%5B1%5D%5Bid%5D=101604&page-template=21043&language=en&currency=USD&billing-email=${getUser()}`
                  }
                }}
                style={{
                  textTransform: 'none',
                  fontFamily: 'RobotoSlab',
                  color: '#FCF8F3',
                  borderRadius: '20px',
                  backgroundColor: subscribed ? '#9e9e9e' : '#7e3e1b',
                  border: '1px solid #FCF8F3',
                  marginTop: 15
                }}
              >
                {subscribed ? 'Already Subscribed' : 'Get Started'}
              </Button>
            </CardContent>
          </Card>&emsp;&emsp;
          <Card style={{ maxWidth: 350, backgroundColor: '#FCF8F3', margin: 'auto', textAlign: 'center', borderRadius: '15px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', }}>
            <CardContent>
              <Typography variant="h5" component="div" gutterBottom style={{ fontFamily: 'RobotoSlab', }}>
                Aniseller Annually
              </Typography>
              {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
                <Typography style={{ fontFamily: 'RobotoSlab', }}>Monthly</Typography>
                <CustomSwitch checked={props.isYearly} onChange={handleToggle} style={{ color: '#7e3e1b', }} />
                <Typography style={{ fontFamily: 'RobotoSlab', }}>Yearly</Typography>
              </Box> */}
              <Typography style={{ color: '#7e3e1b', fontFamily: 'RobotoSlab', fontSize: '2.5rem', fontWeight: 'bold', marginBottom: 5, }}>
                <span style={{ color: "red", textDecoration: "line-through", fontSize: "55%" }}>$490</span>${props.isYearly ? 24 : 290}<Typography component="span" variant="h6">/year</Typography>
              </Typography>
              <Typography style={{ fontFamily: 'RobotoSlab', display: 'flex', alignItems: 'center', margin: '10px 10px 10px 20px', }}>
                <CheckCircleIcon style={{ color: '#7e3e1b', }} sx={{ mr: 1 }} /> Amazon & Walmart Scanners
              </Typography>
              <Typography style={{ fontFamily: 'RobotoSlab', display: 'flex', alignItems: 'center', margin: '10px 10px 10px 20px', }}>
                <CheckCircleIcon style={{ color: '#7e3e1b', }} sx={{ mr: 1 }} /> Unlimited Scans
              </Typography>
              <Typography style={{ fontFamily: 'RobotoSlab', display: 'flex', alignItems: 'center', margin: '10px 10px 10px 20px', }}>
                <CheckCircleIcon style={{ color: '#7e3e1b', }} sx={{ mr: 1 }} /> Priority support
              </Typography>
              <Typography style={{ fontFamily: 'RobotoSlab', display: 'flex', alignItems: 'center', margin: '10px 10px 10px 20px', }}>
                <CheckCircleIcon style={{ color: '#7e3e1b', }} sx={{ mr: 1 }} /> 3 Days Free Trial
              </Typography>
              <Button
                variant="contained"
                disabled={subscribed}
                onClick={() => {
                  props.setIsFlipped(true);
                  if (!props.isAuth) {
                    navigate('/login');
                  } else {
                    window.location.href = `https://store.payproglobal.com/checkout?products%5B1%5D%5Bid%5D=108809&page-template=21043&language=en&currency=USD&billing-email=${getUser()}`
                  }
                }}
                style={{
                  textTransform: 'none',
                  fontFamily: 'RobotoSlab',
                  color: '#FCF8F3',
                  borderRadius: '20px',
                  backgroundColor: subscribed ? '#9e9e9e' : '#7e3e1b',
                  border: '1px solid #FCF8F3',
                  marginTop: 15
                }}
              >
                {subscribed ? 'Already Subscribed' : 'Get Started'}
              </Button>
            </CardContent>
          </Card>
          <img src="https://www.nepeto.com/assets/PIONEERS.png" onClick={() => window.open("https://www.getmarter.com/pioneers-dashboard")} style={{ width: "30%", borderRadius: "20px", boxShadow: "0px 0px 5px 0px green", cursor: "pointer", margin: "auto", marginLeft: "3%", display: "block" }} />
        </Grid>
      </Grid>

      <Box sx={{ mt: 6, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary" style={{ fontFamily: 'RobotoSlab', }}>
          Have questions? Contact us: help@aniseller.com
        </Typography>
      </Box>
    </Container>
  );
};

export default Pricing;